module.exports = __webpack_public_path__ + "img/especialista44.c533ad1c.png";